export class HoursPerDay {
  day: number = 0;
  hours: number = 0;
  half_day: boolean = false;

  constructor(day: number = null) {
    if (day) this.day = day;
    this.hours = 0;
    this.half_day = false;
  }

  public static createInstance(jsonData: any): HoursPerDay {
    return Object.assign(new HoursPerDay(), jsonData);
  }

  public static createInstances(jsonData: any[]): HoursPerDay[] {
    return jsonData.map(HoursPerDay.createInstance);
  }
}
